/* eslint-disable import/no-extraneous-dependencies */
import { createContextualCan } from "@casl/react";
import { createMongoAbility } from "@casl/ability";
import { createContext } from "react";

export const abilityBuilder = (_ability) => {
  return createMongoAbility(_ability);
};

export const AbilityContext = createContext();

export const Can = createContextualCan(AbilityContext.Consumer);

export const permissionUtils = {
  abilityBuilder,
  AbilityContext,
  Can,
  createContextualCan
};
